export const adminKeys = {
  all: ['admin'] as const,
  users: () => [...adminKeys.all, 'users'] as const,
  perspectives: () => [...adminKeys.all, 'perspectives'] as const,
};
